<template>
  <div class="p-6 min-w-max h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Notifications</p>
      <BaseRoundedButton @click="handleMarkAsRead">
        <p class="font-sans">Mark as read</p>
      </BaseRoundedButton>
    </div>
    <!-- body -->
    <div class="my-6">
      <table class="table-auto w-full">
        <tr v-for="notification in notifications" :key="notification.id" class="text-lg">
          <td>
            <div class="flex flex-row">
              <div>
                <div v-if="notification.read == true" class="
                        flex
                        items-center
                        justify-center
                        p-2
                        rounded-full
                        bg-light-gray
                        w-12
                        h-12
                        my-2
                      ">
                  <BellAlertIcon class="w-6 h-6 text-gray" />
                </div>
                <div v-else class="
                        flex
                        items-center
                        justify-center
                        p-2
                        rounded-full
                        bg-light-blue
                        w-12
                        h-12
                        my-2
                      ">
                  <BellAlertIcon class="w-6 h-6 text-blue" />
                </div>
              </div>
              <div class="mx-4 mb-4">
                <p v-if="notification.read == true" class="text-lg text-gray font-medium">
                  {{ notification.title }}
                </p>
                <p v-else class="text-lg text-blue font-medium">
                  {{ notification.title }}
                </p>
                <p class="text-md text-gray font-light">
                  {{ notification.description }}
                </p>
                <p class="text-md text-gray font-light">
                  {{ moment(notification.created_at, "YYYYMMDD").fromNow() }}
                </p>
              </div>
            </div>
          </td>
          <td>
            <div class="flex justify-center relative">
              <Menu>
                <MenuButton>
                  <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                </MenuButton>
                <MenuItems class="
                        p-1
                        space-y-1
                        absolute
                        top-8
                        right-8
                        z-50
                        bg-white
                        border border-light-gray
                        shadow-md
                        rounded-lg
                        w-12/12
                      ">
                  <MenuItem v-if="notification.read == false" @click="handleMarkRead(notification.id)"
                    class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                  <div class="flex flex-row items-center px-4 py-2 min-w-max">
                    <BellSlashIcon class="text-blue w-5 h-5 mr-4" />
                    <p class="text-blue">Mark as Read</p>
                  </div>
                  </MenuItem>
                </MenuItems>
              </Menu>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="mt-auto flex justify-end">
      <BasePagination @navigateToPage="handlePagination($event)" :pageCount="meta.last_page" />
    </div>
  </div>
</template>

<script>
import userService from "../Services/user.service";
import {
  BellAlertIcon,
  EllipsisVerticalIcon,
  BellSlashIcon,
} from "@heroicons/vue/24/solid";
import moment from "moment";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { useToast } from "vue-toastification";
import BasePagination from "../components/BasePagination.vue";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
export default {
  name: "Notification",
  components: {
    BellAlertIcon,
    BellSlashIcon,
    EllipsisVerticalIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    BasePagination,
    BaseRoundedButton,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      notifications: [],
      meta: [],
      params: new URLSearchParams(),
    };
  },
  methods: {
    getNotificationList() {
      userService.getNotification(this.params).then((response) => {
        this.notifications = response.data.data;
        this.meta = response.data.meta;
      });
    },
    getDashBoardSummray() {
      userService.getDashboard().then((response) => {
        this.$store.commit("setNotificationCount", response.data.unread_notification);
      });
    },
    handleMarkRead(value) {
      userService
        .markNotificationRead(value)
        .then(() => {
          this.getDashBoardSummray();
          this.getNotificationList();
          this.toast.success("Marked as read");
        })
        .catch((error) => {
          this.toast.error("Error! Cannot Mark as read.");
          console.log(error);
        });
    },
    handlePagination(value) {
      this.params.set("page", value);
      this.getNotificationList(this.params.toString());
    },
    handleMarkAsRead() {
      this.$Progress.start();
      let unreadIds = [];
      this.notifications.forEach((item) => {
        if (item.read == false) {
          unreadIds.push(item.id);
        }
      });

      unreadIds = "[" + unreadIds + "]";

      let formData = new FormData();
      formData.append("ids", unreadIds);

      userService.markMultipleNotificationRead(formData).then(() => {
        this.$Progress.finish();
        this.getDashBoardSummray();
        this.getNotificationList();
        this.toast.success("Marked all notifications in this page as read");
      }).catch((error) => {
        this.$Progress.fail();
        this.toast.error("Error! Cannot Mark all as read.");
        console.log(error);
      })




      // userService
      //   .markMultipleNotificationRead()
      //   .then(() => {
      //     this.getDashBoardSummray();
      //     this.getNotificationList();
      //     this.toast.success("Marked all as read");
      //   })
      //   .catch((error) => {
      //     this.toast.error("Error! Cannot Mark all as read.");
      //     console.log(error);
      //   });
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getNotificationList();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped></style>